import { NETLIFY_URL } from "../internal-api/commerce/constants"
import { useNetwork, Method } from "../internal-api/network/use-network.hook"

export interface NewsletterAttributes {
  status: number
  message: string
}

interface NewsletterData {
  name: string
  email: string
  channel: string
  mailchimpList?: string
  language: string
  tags?: string[]
  status?: string
}

const config = {
  baseURL: NETLIFY_URL,
}

const useNewsletter = () => {
  const [{ data, loading, error }, fetch] = useNetwork<
    NewsletterAttributes,
    { message: string }
  >({ url: "/subscribe-to-newsletter", method: Method.Post }, config)

  const subscribeToNewsletter = (newsletterData: NewsletterData) => {
    fetch({ data: newsletterData })
  }

  return {
    data,
    loading,
    error,
    subscribeToNewsletter,
  }
}

export default useNewsletter
